import { render, staticRenderFns } from "./CriteriaCardsTemplate.vue?vue&type=template&id=656a598a&scoped=true"
import script from "./CriteriaCardsTemplate.vue?vue&type=script&lang=js"
export * from "./CriteriaCardsTemplate.vue?vue&type=script&lang=js"
import style0 from "./CriteriaCardsTemplate.vue?vue&type=style&index=0&id=656a598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a598a",
  null
  
)

export default component.exports